<template>
  <div class="container">
    <div
      style="
        background-color: #fff;
        padding-top: 12px;
        border-bottom: 1px solid #dddddd;
        position: relative;
        z-index: 35;
      "
    >
      <van-search
        v-model="keyword"
        placeholder="搜索评委名称"
        @search="onSearch"
        @clear="onSearch"
      />
      <van-sticky offset-top="0" z-index="10">
        <div class="type-box">
          <div class="tpb_div" @click.stop="fieldClick">
            <div class="overFlowOne">
              {{ fId==3?"数智类评委": "照明类评委" }}
            </div>
            <span
              class="iconfont"
              :class="fieldShow ? 'icon-shangla' : 'icon-xiala'"
            ></span>
            <div class="tpbv_area" v-if="fieldShow">
              <div :class="fId == 1 ? 'act' : ''" @click.stop="fIdSelect(1)">
                照明类评委
              </div>              
              <div :class="fId == 3 ? 'act' : ''" @click.stop="fIdSelect(3)">
                数智类评委
              </div>
            </div>
          </div>
          <div class="tpb_div" @click.stop="jgClick">
            <div class="overFlowOne">
              {{
                jId == 1
                  ? "提名评委"
                  : jId == 2
                  ? "合作机构"
                  : jId == 3
                  ? "推荐官"
                  : "终审评委"
              }}
            </div>
            <span
              class="iconfont"
              :class="jgShow ? 'icon-shangla' : 'icon-xiala'"
            ></span>
            <div class="tpbv_area" v-if="jgShow">
              <div :class="jId == 1 ? 'act' : ''" @click.stop="jIdSelect(1)">
                提名评委
              </div>
              <div :class="jId == 2 ? 'act' : ''" @click.stop="jIdSelect(2)">
                合作机构
              </div>
              <div :class="jId == 0 ? 'act' : ''" @click.stop="jIdSelect(0)">
                终审评委
              </div>
              <div :class="jId == 3 ? 'act' : ''" @click.stop="jIdSelect(3)">
                推荐官
              </div>
            </div>
          </div>
        </div>
      </van-sticky>
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getList"
      class="list-box"
    >
      <div
        class="lb_item"
        v-for="(item, index) in list"
        :key="index"
        @click.stop="toHomePage(item.MemberID)"
      >
        <van-image :src="item.Photo" fit="contain"></van-image>
        <div>{{ item.NickName }}</div>
      </div>
    </van-list>

    <div class="noDataBox" v-if="list.length == 0">
      <div class="kongIcon"><span class="iconfont icon-kong"></span></div>
      <div>什么也没有！</div>
    </div>
    <!-- 透明遮盖层 -->
    <div
      class="mask-layer"
      v-if="fieldShow || jgShow"
      @click.stop="maskLayerClose"
    ></div>
  </div>
</template>
<script>
import { List, Sticky, Image, Search } from "vant";
import { juryList } from "@/api/lighting";
export default {
  name: "judges",
  components: {
    "van-sticky": Sticky,
    "van-list": List,
    "van-image": Image,
    "van-search": Search,
  },
  data() {
    return {
      keyword: "",
      fId: 1, //照明类评委1  智能生态奖评委2，数智类评委3
      fieldShow: false,
      jId: 1, //终审评委0  提名评委1  合作机构2(照明板块才有)  推荐官3
      jgShow: false,

      list: [],
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
    };
  },
  methods: {
    //分类下拉
    fieldClick() {
      this.fieldShow = !this.fieldShow;
      this.jgShow = false;
    },

    fIdSelect(n) {
      this.fId = n;
      this.pageIndex = 1;
      this.getList();
    },

    //类型下拉
    jgClick() {
      this.fieldShow = false;
      this.jgShow = !this.jgShow;
    },

    jIdSelect(n) {
      this.jId = n;
      this.pageIndex = 1;
      this.getList();
    },

    onSearch() {
      this.pageIndex = 1;
      this.getList();
    },

    //关闭弹窗
    maskLayerClose() {
      this.fieldShow = false;
      this.jgShow = false;
    },

    getList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 18,
          PageIndex: that.pageIndex,
        },
        KeyWord: that.keyword,
        AwardYear: that.awardYear,
        FieldId: that.fId,
        JuryGroup: that.jId,
      };
      juryList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    toHomePage(id) {
      this.$router.push({
        path: "/homePage",
        query: {
          mid: id,
        },
      });
    },
  },

  mounted() {
    if (!this.Common._isMobile()) {
      window.location.href = "https://sdj.alighting.com/jurylist.html";
    }
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background-color: #f0f0f4;
  padding-bottom: 75px;
}

.container >>> .van-search__content {
  border: 0.01rem solid #c2c2c2;
  background: #fff;
}
.container >>> .van-field__control {
  font-size: 12px;
}

.type-box {
  background-color: #fff;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 10;
  font-size: 13px;
  color: #000733;
}

.tpb_div {
  flex: 1;
  width: 1%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tpb_div > div.overFlowOne {
  max-width: calc(100% - 12px);
}

.tpb_div .iconfont {
  font-size: 7px;
  color: #9699a9;
  padding-left: 5px;
}

.tpbv_area {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  /* height: auto; */
  padding: 15px 15px;
  box-sizing: border-box;
  background-color: #fff;
}

.tpbv_area div {
  width: 50%;
  line-height: 15px;
  padding: 7px 5px;
  box-sizing: border-box;
}

.tpbv_area div.act {
  color: #ff6e01;
}

.list-box {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  color: #000733;
}

.lb_item {
  width: 100px;
  text-align: center;
  margin: 15px 0 0 18px;
}

.lb_item >>> .van-image {
  background-color: #fff;
  width: 100%;
  height: 100px;
  border: 1px solid #e4e4e4;
  margin-bottom: 6px;
  display: block;
}
.lb_item >>> .van-image__img {
  border-radius: 5px;
}


.noDataBox .icon-kong {
  color: #dddddd;
}
</style>